<div class="tw-relative tw-w-full tw-h-full tw-bg-gray-75 tw-font-body tw-rounded-tl-5 tw-rounded-tr-5">
  <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2">
    <div class="tw-absolute -tw-top-[24%] tw-bg-gradient-white-to-gray-2 tw-rounded-full">
      <img class="tw-w-[126px] tw-h-[126px] tw-rounded-full tw-object-cover" style="object-position: center -30%;"  src="https://cdn.cureskin.com/app/img/dr_charu_single.png"/>
    </div>
    <div class="tw-absolute tw-w-[26px] tw-h-[26px] tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-[15px] tw-right-[10px] tw-p-1 tw-rounded-full tw-bg-gray-100" (click)="closeBottomSheet()">
      <div class="tw-text-black tw-text-500 tw-font-bold">&#10005;</div>
    </div>
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-8 tw-pt-[88px] tw-pb-10 tw-px-6">
      <div class="tw-w-[80%]">
        <h2 class="tw-text-600 tw-font-bold tw-text-center" i18n="@@welcomeBackFullNameCapitalize">Welcome back, <span class="tw-capitalize">{{data?.user?.get('PatientName')}}</span></h2>
        <p class="tw-text-300 tw-font-medium tw-text-gray-500 tw-text-center tw-mt-2" i18n="@@getBackOnYourRoutine">Get back on your routine with a free doctor checkup and a doctor call</p>
      </div>
      <div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-bg-teal-600 tw-px-6 tw-py-3.5 tw-rounded-3" (click)="handleClick(true)">
        <p class="tw-capitalize tw-text-400 tw-font-semibold tw-text-white" i18n="@@takeDoctorCheckup">take doctor checkup</p>
      </div>
    </div>
  </div>
</div>
